var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page linear-log-page" }, [
    _c("div", { staticClass: "saas-hero card-saas linear-page-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/home" } }, [
              _vm._v(_vm._s(_vm.trans("general.home"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("mail.email_log")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "linear-eyebrow" }, [
          _vm._v(_vm._s(_vm.trans("mail.email_log"))),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(_vm._s(_vm.trans("mail.email_log"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.email_logs.total
      ? _c(
          "div",
          { staticClass: "admin-list-table-card linear-table-card mt-3" },
          [
            _c(
              "div",
              { staticClass: "linear-section-head linear-section-head--table" },
              [
                _c("div", [
                  _c("span", [_vm._v(_vm._s(_vm.trans("mail.email_log")))]),
                  _vm._v(" "),
                  _c("h4", [_vm._v(_vm._s(_vm.trans("mail.email")))]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                {
                  staticClass: "table admin-data-table linear-dense-table mb-0",
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.trans("mail.receiver")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.trans("mail.subject")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.trans("mail.sent_at")))]),
                      _vm._v(" "),
                      _c("th", { staticClass: "admin-table-actions-cell" }, [
                        _vm._v(_vm._s(_vm.trans("general.actions"))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.email_logs.data, function (email_log) {
                      return _c("tr", { key: email_log.id }, [
                        _c("td", [
                          _c("span", {
                            staticClass: "linear-table-primary",
                            domProps: {
                              textContent: _vm._s(email_log.to_address),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", {
                            staticClass:
                              "linear-table-muted linear-table-truncate",
                            domProps: {
                              textContent: _vm._s(email_log.subject),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { staticClass: "linear-table-muted" }, [
                            _vm._v(
                              _vm._s(_vm._f("moment")(email_log.created_at))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "admin-table-actions-cell" },
                          [
                            _c(
                              "table-row-action-dropdown",
                              [
                                _c(
                                  "b-dropdown-item-button",
                                  {
                                    attrs: {
                                      "data-toggle": "modal",
                                      "data-target": ".email-log-detail",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fetchEmailLog(email_log)
                                      },
                                    },
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "eye" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.trans("mail.view")) +
                                        "\n                                "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item-button",
                                  {
                                    directives: [
                                      {
                                        name: "confirm",
                                        rawName: "v-confirm",
                                        value: {
                                          ok: _vm.confirmDelete(email_log),
                                        },
                                        expression:
                                          "{ok: confirmDelete(email_log)}",
                                      },
                                    ],
                                    staticClass: "admin-row-actions__danger",
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "trash" },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.trans("general.delete")) +
                                        "\n                                "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "admin-table-pagination-wrap" },
              [
                _c("pagination-record", {
                  attrs: {
                    "page-length": _vm.filterEmailLogForm.page_length,
                    records: _vm.email_logs,
                  },
                  on: {
                    "update:pageLength": function ($event) {
                      return _vm.$set(
                        _vm.filterEmailLogForm,
                        "page_length",
                        $event
                      )
                    },
                    "update:page-length": function ($event) {
                      return _vm.$set(
                        _vm.filterEmailLogForm,
                        "page_length",
                        $event
                      )
                    },
                    updateRecords: _vm.getEmailLogs,
                  },
                  nativeOn: {
                    change: function ($event) {
                      return _vm.getEmailLogs.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.email_logs.total
      ? _c(
          "div",
          {
            staticClass:
              "admin-list-table-card admin-empty-state linear-empty-state mt-3",
            attrs: { role: "status" },
          },
          [
            _c("div", { staticClass: "admin-empty-state__inner" }, [
              _c(
                "div",
                {
                  staticClass: "admin-empty-state__icon-wrap",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "mail" } })],
                1
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "admin-empty-state__title" }, [
                _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "admin-empty-state__text" }, [
                _vm._v(_vm._s(_vm.trans("mail.email_log"))),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade email-log-detail admin-modal-pro",
        attrs: {
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "emailLogDetail",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c(
            "div",
            {
              staticClass:
                "modal-content admin-modal-pro__content linear-email-modal",
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h4",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "emailLogDetail" },
                  },
                  [_vm._v(_vm._s(_vm.trans("mail.email")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _vm._v(" "),
              _vm.email_log
                ? _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "linear-email-modal__head" }, [
                      _c("div", [
                        _c("span", [_vm._v(_vm._s(_vm.trans("mail.subject")))]),
                        _vm._v(" "),
                        _c("h4", [_vm._v(_vm._s(_vm.email_log.subject))]),
                      ]),
                      _vm._v(" "),
                      _c("time", [
                        _vm._v(
                          _vm._s(_vm._f("moment")(_vm.email_log.created_at))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "linear-email-modal__meta" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.trans("mail.sender") +
                              ": " +
                              _vm.email_log.from_address
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.trans("mail.receiver") +
                              ": " +
                              _vm.email_log.to_address
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "linear-email-modal__body",
                      domProps: { innerHTML: _vm._s(_vm.email_log.body) },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                    attrs: { type: "button", "data-dismiss": "modal" },
                  },
                  [_vm._v(_vm._s(_vm.trans("general.close")))]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }